export class Observer
{
    constructor(oberservationContainer, targetEl)
    {
        this.oberservationContainer = oberservationContainer;
        this.targetEl = targetEl;
        this.observer = new IntersectionObserver(
            e => {
                this.process(e)
            },
            {
                threshold: 0,
                root: null,
                rootMargin: '-55px 0px 0px 0px'
            });
        this.start_observing();
    }

    start_observing()
    {
        this.observer.observe(this.oberservationContainer);
    }

    process(e)
    {
        if(this.oberservationContainer.classList.contains('mod--header-full') ||
           this.oberservationContainer.classList.contains('mod--header-half') ||
           this.oberservationContainer.classList.contains('w__listen-to--figure'))
        {
            e[0].isIntersecting === true
                ? this.targetEl.classList.remove('mod--scroll-out')
                : this.targetEl.classList.add('mod--scroll-out');
        }
        else if(this.targetEl.classList.contains('w__photo--figure'))
        {
            e[0].isIntersecting === true
                ? this.targetEl.classList.remove('active')
                : this.targetEl.classList.add('active');
        }
    }
}
